import store from '@polleverywhere/redux'

function equality (oldState, newState) {
  return oldState === newState
}

// Listen to individual redux selector changes
// Allow passing in an equality method
export default function listenToSelector (select, onChange, isEqual = equality) {
  let currentState = select(store.getState())

  function handleChange () {
    const nextState = select(store.getState())
    if (!isEqual(currentState, nextState)) {
      const prevState = currentState
      currentState = nextState
      onChange(currentState, prevState)
    }
  }

  // return unsubscribe method
  return store.subscribe(handleChange)
}
